import React from 'react';

export default function Layout({ children, title }) {
  return (
    <div className="">
      <header className="bg-white dark:bg-gray-900 font-poppins md:rounded-md rounded-b-2xl rounded-t-none transition">
        <div className="max-w-9xl mx-auto px-4 py-2 ">
          <h1 className="md:text-3xl text-lg font-semibold text-gray-900 dark:text-white">{title}</h1>
        </div>
      </header>
      <main className="py-2">
        {children}
      </main>
    </div>
  );
}
